const { toFloat, toInt } = require('@/functions/transform');

/**
 * @constructor
 */
const GiftVoucherDenomination = function () {
    this.denomination = null;
    this.ID = null;
};

GiftVoucherDenomination.prototype = {
    getHydrationMap() {
        return {
            ID: {
                field: ['ID', 'giftVoucherDenominationID'],
                transform: toInt,
            },
            denomination: toFloat,
        };
    },
};

module.exports = GiftVoucherDenomination;
